import { forwardRef, useState, useEffect, useImperativeHandle } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const Modal = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal: () => setOpen(true),
    closeModal: () => setOpen(false),
  }));

  useEffect(() => {
    function onKeyup(e) {
      if (e.key === 'Escape') setOpen(false);
    }

    function onClickOutside(e) {
      if (e.target.classList.contains('modal-backdrop')) {
        setOpen(false);
      }
    }

    document.addEventListener('keyup', onKeyup);
    document.addEventListener('click', onClickOutside);

    return () => {
      document.removeEventListener('keyup', onKeyup);
      document.removeEventListener('click', onClickOutside);
    };
  }, [open, setOpen]);

  return (
    <AnimatePresence>
      {open && (
        <>
          <div className="fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-25 z-20 flex items-center justify-center modal-backdrop p-4 ">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0 }}
              className="bg-[#f5f5f5] rounded-lg z-60 min-w-[380px] md:w-7/12 max-h-[85%] overflow-y-auto  p-4 mt-20"
            >
              {props.children}
            </motion.div>
          </div>
        </>
      )}
    </AnimatePresence>
  );
});

export default Modal;
